export const GET_PROVIDER_LISTS = 'GET_PROVIDER_LISTS';
